import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api.service';
import { IccCatalogedDrugImport } from '../../models/icc/icc-cataloged-drug-import.model';
import { IccImportFilters } from '../../models/icc/icc-import-settings.model';
import { LimitOffsetPagingMeta } from 'app/core/models/paged-results/limit-offset-paging.model';
import { PagedResults } from 'app/core/models/paged-results/paged-results.model';

export class PagedIccCatalogedDrugImports implements PagedResults {
  catalogedDrugImports: IccCatalogedDrugImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.catalogedDrugImports;
  }
}

@Injectable()
export class IccCatalogedDrugImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<IccCatalogedDrugImport> {
    return this.http.get<IccCatalogedDrugImport>(`${environment.captureApi.url}/icc/cataloged_drug_imports/${id}`);
  }

  getList(
    paging: { page: number; pageSize: number } = null,
    filters: IccImportFilters = null
  ): Observable<PagedIccCatalogedDrugImports> {
    const params = new URLSearchParams();

    if (filters && filters.selectedClientIds) {
      filters.selectedClientIds.forEach(clientId => params.append('client_ids[]', clientId));
    }

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedIccCatalogedDrugImports>(
      `${environment.captureApi.url}/icc/cataloged_drug_imports?${params.toString()}`
    );
  }

  create(clientId: number, name: string, signedId: string): Observable<IccCatalogedDrugImport> {
    return this.http.post<IccCatalogedDrugImport>(`${environment.captureApi.url}/icc/cataloged_drug_imports`, {
      catalogedDrugImport: { clientId, name, signedId },
    });
  }

  update(id, name): Observable<IccCatalogedDrugImport> {
    return this.http.put<IccCatalogedDrugImport>(`${environment.captureApi.url}/icc/cataloged_drug_imports/${id}`, {
      catalogedDrugImport: { name },
    });
  }

  cancel(id): Observable<IccCatalogedDrugImport> {
    return this.http.patch<IccCatalogedDrugImport>(
      `${environment.captureApi.url}/icc/cataloged_drug_imports/${id}/cancel`,
      {}
    );
  }
}
